import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';

export default function Hero() {
  const { t } = useTranslation('common');
  return (
    <div className="bg-gradient-to-b from-[#5644BF] to-[#181436] lg:px-0 px-4 lg:pb-0 pb-10">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 grid-cols-1 lg:gap-20 gap-8 pb-0 lg:py-20 py-10 text-white">
        <div className="lg:pr-12">
          <h1 className="lg:text-6xl text-4xl font-bold text-white">
            <div className="bg-gradient-to-r from-[#63FBFC] via-[#D2DCB0] to-[#EC56EC] bg-clip-text text-transparent w-fit">
              {t('Boost your income')}
            </div>{' '}
            <div>{t('by promoting Dolphin Radar')}</div>
          </h1>
          <div className="lg:text-lg text-base lg:mt-8 mt-4">
            {t('Join the Dolphin Radar affiliate program for')}{' '}
            <span className="text-[#6FF7F4] font-bold">{t('30% commission for 3 months')}</span>.{' '}
            {t(
              'Promote it on social, blogs or videos—whatever works for you. It’s easy to share and even easier to earn.'
            )}
          </div>
          <Link
            href="https://dolphin-radar.getrewardful.com/signup?campaign=dolphinradar-affiliate-user-30"
            target="_blank"
            className="lg:block hidden"
          >
            <button
              className="px-16 py-2 text-sm rounded-full bg-[#725CFF] mt-12"
              onClick={() => ga_logEvent(EventName.affiliate_apply_click)}
            >
              {t('Apply Now')}
            </button>
          </Link>
        </div>
        <div className="flex justify-center items-center lg:px-0 px-8">
          <Image src="/images/affiliates/aff-hero.webp" alt="hero-image" width={500} height={500} />
        </div>
      </div>
      <div className="lg:hidden block">
        <Link
          href="https://dolphin-radar.getrewardful.com/signup?campaign=dolphinradar-affiliate-user-30"
          target="_blank"
        >
          <button className="w-full text-white py-4 text-base rounded-full bg-[#725CFF] mt-12">{t('Apply Now')}</button>
        </Link>
      </div>
    </div>
  );
}
